import { render, staticRenderFns } from "./SubscriptionFrame.vue?vue&type=template&id=5ad5c2b0&scoped=true"
import script from "./SubscriptionFrame.vue?vue&type=script&lang=js"
export * from "./SubscriptionFrame.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionFrame.vue?vue&type=style&index=0&id=5ad5c2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.6_supports-color@8.1.1____6d4bc6e641adf69df12baf0f484d3174/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad5c2b0",
  null
  
)

export default component.exports